import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex row gap-2" };
const _hoisted_2 = {
    class: "label mb-2",
    style: { "margin-top": "-10px" }
};
const _hoisted_3 = { class: "feature" };
const _hoisted_4 = { class: "feature-body" };
const _hoisted_5 = { class: "feature-title" };
const _hoisted_6 = { class: "feature-desc label" };
const _hoisted_7 = { class: "feature-desc label" };
const _hoisted_8 = { class: "feature" };
const _hoisted_9 = { class: "feature-body" };
const _hoisted_10 = { class: "feature-title" };
const _hoisted_11 = { class: "feature-desc label" };
const _hoisted_12 = { class: "feature-desc label" };
const _hoisted_13 = { class: "feature" };
const _hoisted_14 = { class: "feature-body" };
const _hoisted_15 = { class: "feature-title" };
const _hoisted_16 = { class: "feature-desc label" };
const _hoisted_17 = { class: "feature-desc label" };
const _hoisted_18 = { class: "list-low" };
const _hoisted_19 = { class: "features" };
const _hoisted_20 = { class: "feature" };
const _hoisted_21 = { class: "feature-body" };
const _hoisted_22 = { class: "ul-list label" };
import UList from "@/components/uikit/uComponents/UList.vue";
import UTooltip from "@/components/uikit/uComponents/UTooltip.vue";
import { computed, onMounted, onUnmounted, ref } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'RwaProjectInvestmentStrategy',
    props: {
        title: {
            type: String,
            default: "Investment strategy"
        },
        applicationType: {
            type: String,
            default: "income"
        }
    },
    setup(__props) {
        const windowWidth = ref(window.innerWidth);
        const handleResize = () => {
            windowWidth.value = window.innerWidth;
        };
        onMounted(() => {
            window.addEventListener("resize", handleResize);
        });
        onUnmounted(() => {
            window.removeEventListener("resize", handleResize);
        });
        const listDirection = computed(() => {
            return windowWidth.value <= 720 ? "column" : "row";
        });
        const props = __props;
        const income = ref({
            title: "Income",
            tooltip: "Priority: rental income and stable payouts.",
            description: "Priority: rental income and stable payouts.",
            blockTitle1: "Income (Rent)",
            blockDescription1: "Built for stable distributions",
            blockLabel1: "Demand • Low vacancy • Net yield",
            blockTitle2: "Capital Growth",
            blockDescription2: "Upside is a bonus, not the base case",
            blockLabel2: "Location • Quality • Scarcity",
            blockTitle3: "Risk Control",
            blockDescription3: "Conservative selection and controls",
            blockLabel3: "Liquidity • Due diligence • SPV",
            list1: "Established tenant demand in the area",
            list2: "Ready / near-ready to lease",
            list3: "Comparable rents support expected levels",
            list4: ""
        });
        const growth = ref({
            title: "Growth",
            tooltip: "Priority: price appreciation; income may be secondary.",
            description: "Priority: price appreciation; income may be secondary.",
            blockTitle1: "Income (Rent)",
            blockDescription1: "Rent is supportive, not the main driver",
            blockLabel1: "Buffer • Flexibility • Coverage",
            blockTitle2: "Capital Growth",
            blockDescription2: "Primary goal: capital appreciation",
            blockLabel2: "Upside • Location • Scarcity",
            blockTitle3: "Risk Control",
            blockDescription3: "Timing and exit discipline",
            blockLabel3: "Liquidity • Thresholds • SPV",
            list1: "Location and infrastructure support upside",
            list2: "Limited supply in the target segment",
            list3: "Defined exit triggers (price/time)",
            list4: ""
        });
        const risk = ref({
            title: "Risk Control",
            tooltip: "Balance between rental income and capital growth potential.",
            description: "Balance between rental income and capital growth potential.",
            blockTitle1: "Income (Rent)",
            blockDescription1: "Income supports performance over the hold",
            blockLabel1: "Demand • Lease strategy • Payouts",
            blockTitle2: "Capital Growth",
            blockDescription2: "Growth is a co-driver",
            blockLabel2: "Infrastructure • District • Demand",
            blockTitle3: "Risk Control",
            blockDescription3: "Scenario-led planning and exit discipline",
            blockLabel3: "Liquidity • Triggers • SPV",
            list1: "Demand supports both leasing and resale",
            list2: "Clear operating economics and management",
            list3: "Comparable deals support the pricing range",
            list4: ""
        });
        const informationObj = computed(() => {
            switch (props.applicationType) {
                case "growth":
                    return growth.value;
                case "risk":
                    return risk.value;
                case "income":
                default:
                    return income.value;
            }
        });
        return (_ctx, _cache) => {
            const _component_UIcon = _resolveComponent("UIcon");
            const _component_UContent = _resolveComponent("UContent");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_UContent, {
                    title: props.title,
                    "has-title-delimiter": false,
                    "header-align": "space-between",
                    "header-padding": "0px 0px 15px 0px"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_UContent, {
                            "is-card-bordered": "",
                            "header-align": "space-between",
                            "header-padding": "0px"
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                    _createTextVNode(_toDisplayString(informationObj.value.title), 1),
                                    _createVNode(UTooltip, {
                                        tooltip: informationObj.value.tooltip
                                    }, null, 8, ["tooltip"])
                                ]),
                                _createElementVNode("div", _hoisted_2, _toDisplayString(informationObj.value.description), 1),
                                _createElementVNode("div", null, [
                                    _createVNode(UList, {
                                        "flex-direction": listDirection.value,
                                        "justify-content": "space-between",
                                        class: "mb-3"
                                    }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_3, [
                                                _createVNode(_component_UIcon, {
                                                    "icon-size": "56px",
                                                    icon: "hand_coins",
                                                    class: "icon"
                                                }),
                                                _createElementVNode("div", _hoisted_4, [
                                                    _createElementVNode("div", _hoisted_5, _toDisplayString(informationObj.value.blockTitle1), 1),
                                                    _createElementVNode("div", _hoisted_6, _toDisplayString(informationObj.value.blockDescription1), 1),
                                                    _createElementVNode("div", _hoisted_7, _toDisplayString(informationObj.value.blockLabel1), 1)
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_8, [
                                                _createVNode(_component_UIcon, {
                                                    "icon-size": "56px",
                                                    icon: "chart_line_up",
                                                    class: "icon"
                                                }),
                                                _createElementVNode("div", _hoisted_9, [
                                                    _createElementVNode("div", _hoisted_10, _toDisplayString(informationObj.value.blockTitle2), 1),
                                                    _createElementVNode("div", _hoisted_11, _toDisplayString(informationObj.value.blockDescription2), 1),
                                                    _createElementVNode("div", _hoisted_12, _toDisplayString(informationObj.value.blockLabel2), 1)
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_13, [
                                                _createVNode(_component_UIcon, {
                                                    "icon-size": "56px",
                                                    icon: "chart_bar",
                                                    class: "icon"
                                                }),
                                                _createElementVNode("div", _hoisted_14, [
                                                    _createElementVNode("div", _hoisted_15, _toDisplayString(informationObj.value.blockTitle3), 1),
                                                    _createElementVNode("div", _hoisted_16, _toDisplayString(informationObj.value.blockDescription3), 1),
                                                    _createElementVNode("div", _hoisted_17, _toDisplayString(informationObj.value.blockLabel3), 1)
                                                ])
                                            ])
                                        ]),
                                        _: 1
                                    }, 8, ["flex-direction"])
                                ]),
                                _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_18, [
                                        _createElementVNode("div", _hoisted_19, [
                                            _createElementVNode("div", _hoisted_20, [
                                                _createElementVNode("div", _hoisted_21, [
                                                    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "mb-1" }, " Why we’re confident: ", -1)),
                                                    _createElementVNode("ul", _hoisted_22, [
                                                        _createElementVNode("li", null, _toDisplayString(informationObj.value.list1), 1),
                                                        _createElementVNode("li", null, _toDisplayString(informationObj.value.list2), 1),
                                                        _createElementVNode("li", null, _toDisplayString(informationObj.value.list3), 1)
                                                    ])
                                                ])
                                            ]),
                                            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "feature" }, [
                                                _createElementVNode("div", { class: "feature-body" }, [
                                                    _createElementVNode("div", { class: "mb-1" }, " Disclaimer "),
                                                    _createElementVNode("div", { class: "ul-list label" }, " The information is of a general nature and does not constitute an investment recommendation or an offer to buy/sell any instruments. Investments involve risk, including possible loss of capital. Evaluate your goals and consult with an independent specialist. ")
                                                ])
                                            ], -1))
                                        ])
                                    ])
                                ])
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }, 8, ["title"])
            ]));
        };
    }
});
